import services from '@/config/services'
import FileManager from '@/services/ask-file-manager/index.js'

export default class PraticheService{
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.praticheUrl = `${services.ask_pratiche.url}`
    this.praticheBaseUrl = `${services.ask_pratiche_base.url}`
    this.apiUrl = `${services.ask_api.url}/management`
    this.filemanager = new FileManager()
    this.baseUrl = `${services.ask_api.url}/management`;
    this.backendUrl = `${services.ask_backend.url}`
  }

  async getPodByState(codTypeState) {

    // let path = this.currentUser.user[0].profile.id == 1 ? this.backendUrl : this.praticheUrl
    // const url = `${path}/operation/pods/pod-by-state?cod_type_state=${codTypeState}`;

    let items = {};
    const url = `${this.praticheUrl}/operation/pods/pod-by-state?cod_type_state=${codTypeState}`;
    try {
      const res = await this.http.get(url);
      items = res;
      // if (successMessage) this.eventBus.emit('data-load-success', { message: successMessage });
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
    } finally {
      this.eventBus.emit('data-loaded');
    }
    return items.data;
  }

  // PDR
  async get_sospensione_richiesta_pdr() {
    let items = {};
    const url = `${this.praticheUrl}/operation/pdrs/sospensioni/get-sospensione-richiesta-pdr`;
    try {
      let res = await this.http.get(url);
      items = res;
      // this.eventBus.emit('data-load-success', {message: 'Richieste Sospensioni pdr Caricate'})
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return items.data;
  }

  async get_sospensione_lavorazione_pdr() {
    let items = {};
    const url = `${this.praticheUrl}/operation/pdrs/sospensioni/get-sospensione-lavorazione-pdr`;
    try {
      let res = await this.http.get(url);
      items = res;
      // this.eventBus.emit('data-load-success', {message: 'Sospensioni in Lavorazione pdr caricati'})
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return items.data;
  }

  async get_pdr_sospesi() {
    let items = {};
    const url = `${this.praticheUrl}/operation/pdrs/sospensioni/get-sospesi-pdr`;
    try {
      let res = await this.http.get(url);
      items = res;
      // this.eventBus.emit('data-load-success', {message: 'Pdr sospesi caricati'})
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return items.data;
  }

  async get_riattivazione_richiesta_pdr() {
    let items = {};
    const url = `${this.praticheUrl}/operation/pdrs/riattivazione/get-riattivazione-richiesta-pdr`;
    try {
      let res = await this.http.get(url);
      items = res;
      // this.eventBus.emit('data-load-success', {message: 'Richieste Riattivazione pdr Caricate'})
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return items.data;
  }

  async get_riattivazione_lavorazione_pdr() {
    let items = {};
    const url = `${this.praticheUrl}/operation/pdrs/riattivazione/get-riattivazione-lavorazione-pdr`;
    try {
      let res = await this.http.get(url);
      items = res;
      // this.eventBus.emit('data-load-success', {message: 'Riattivazioni in lavorazione pdr caricati'})
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return items.data;
  }

  async get_pdr_riattivati() {
    let items = {};
    const url = `${this.praticheUrl}/operation/pdrs/riattivazione/get-riattivati-pdr`;
    try {
      let res = await this.http.get(url);
      items = res;
      // this.eventBus.emit('data-load-success', {message: 'Pdr riattivati caricati'})
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return items.data;
  }

  async get_pdr_sosp_ko() {
    let items = {};
    const url = `${this.praticheUrl}/operation/pdrs/riattivazione/get-sosp-ko`;
    try {
      let res = await this.http.get(url);
      items = res;
      // this.eventBus.emit('data-load-success', {message: 'Pdr riattivati caricati'})
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return items.data;
  }

  async get_pdr_riat_ko() {
    let items = {};
    const url = `${this.praticheUrl}/operation/pdrs/riattivazione/get-riat-ko`;
    try {
      let res = await this.http.get(url);
      items = res;
      // this.eventBus.emit('data-load-success', {message: 'Pdr riattivati caricati'})
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return items.data;
  }

  async generazioneCsvSospensioniRiattivazioniPdr(pdrIds = [], type = 'sospensioni') {
    const url = `${this.praticheUrl}/operation/pdrs/sospensioni-riattivazioni/genera-csv`;
    const formattedDate = this.get_file_date();

    try {
        const response = await this.http.post(url, { pdrIds, type }, { responseType: 'blob' });

        if (response.status !== 200) {
            throw new Error('Errore durante la generazione del CSV');
        }

        const blob = new Blob([response.data], { type: 'application/zip' });
        // const blob = new Blob([response.data], { type: 'text/csv' });
        const urlObject = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = urlObject;
        link.setAttribute('download', `${type}_richieste_pdr_${formattedDate}.zip`);
        // link.setAttribute('download', `${type}_richieste_pod.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.eventBus.emit('data-load-success', { message: 'File CSV generato e scaricato con successo' });

        return 'ok';
    } catch (err) {
        this.eventBus.emit('data-load-error', { message: err.message, url });
        console.error('Errore durante la generazione o il download del file CSV:', err);
    } finally {
        this.eventBus.emit('data-loaded');
    }
  }

  async generazioneCsvSospensioniRiattivazioniPod(podIds = [], type = 'sospensioni', cambiaStato = true) {
    const url = `${this.praticheUrl}/operation/pods/sospensioni-riattivazioni/genera-csv`;
    const formattedDate = this.get_file_date();

    try {
        const response = await this.http.post(url, { podIds, type, cambiaStato }, { responseType: 'blob' });

        if (response.status !== 200) {
            throw new Error('Errore durante la generazione del CSV');
        }

        // const blob = new Blob([response.data], { type: 'application/zip' });
        const blob = new Blob([response.data], { type: 'text/csv' });
        const urlObject = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = urlObject;
        // link.setAttribute('download', `${type}_richieste_pod.zip`);
        link.setAttribute('download', `${type}_richieste_pod_${formattedDate}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.eventBus.emit('data-load-success', { message: 'File CSV generato e scaricato con successo' });

        return 'ok';
    } catch (err) {
        this.eventBus.emit('data-load-error', { message: err.message, url });
        console.error('Errore durante la generazione o il download del file CSV:', err);
    } finally {
        this.eventBus.emit('data-loaded');
    }
  }

  async cambiaStatoPodPdr(pods, pdrs, stato) {
    const url = `${this.praticheUrl}/operation/cambia-stato-pratica`;

    try {
        let res = await this.http.post(url, { pods, pdrs, stato });
        console.log(res);
        this.eventBus.emit('data-load-success', {message: res.data.message});
        return res;
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url});
    }
  }

  async geTipiStatoFornituraSospensioniRiattivazioni() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-stato-fornitura-sosp-riat`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  get_file_date() {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0'); // 0-11
    const year = now.getFullYear();

    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    const formattedDate = `${day}_${month}_${year}_${hours}_${minutes}_${seconds}`;
    return formattedDate;
  }

  async sospendi_riattiva_pdrs(pdrs, type){
    let items = {}
    const url = `${this.praticheUrl}/operation/pdrs/sospensioni-riattivazioni`
    try {
        let res = await this.http.post(url, {pdrs, type})
        items = res.data
        this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          items
        }    
    }

  }

  async sospendi_riattiva_pods(pods, type){
    let items = {}
    const url = `${this.praticheUrl}/operation/pods/sospensioni-riattivazioni/new`
    try {
        let res = await this.http.post(url, {pods, type})
        items = res.data
        this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          items
        }    
    }

  }

  async aggiungiNotaSospensioneRiattivazione(payload) {
    const url = `${this.praticheBaseUrl}/api/sospensioni-riattivazioni-management/note/aggiungi`;

    try {
      const res = await this.http.post(url, payload);
      this.eventBus.emit('data-load-success', { message: res.data.message });
      return res.data;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
      return null;
    } finally {
      this.eventBus.emit('data-loaded');
    }
  }

  async aggiornaNotaSospensioneRiattivazione(payload) {
    const url = `${this.praticheBaseUrl}/api/sospensioni-riattivazioni-management/note/aggiorna`;

    try {
      const res = await this.http.put(url, payload);
      this.eventBus.emit('data-load-success', { message: res.data.message });
      return res.data;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
      return null;
    } finally {
      this.eventBus.emit('data-loaded');
    }
  }

  async eliminaNotaSospensioneRiattivazione(payload) {
    const url = `${this.praticheBaseUrl}/api/sospensioni-riattivazioni-management/note/elimina`;

    try {
      const res = await this.http.delete(url, {
        data: payload,
      });

      this.eventBus.emit('data-load-success', { message: res.data.message });
      return res.data;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
      return null;
    } finally {
      this.eventBus.emit('data-loaded');
    }
  }

  async aggiungiAppuntamentoSospensioneRiattivazione(payload) {
    const url = `${this.praticheBaseUrl}/api/sospensioni-riattivazioni-management/appuntamento/aggiungi`;

    try {
      const res = await this.http.post(url, payload);
      this.eventBus.emit('data-load-success', { message: res.data.message });
      return res.data;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
      return null;
    } finally {
      this.eventBus.emit('data-loaded');
    }
  }

  async aggiornaAppuntamentoSospensioneRiattivazione(payload) {
    const url = `${this.praticheBaseUrl}/api/sospensioni-riattivazioni-management/appuntamento/aggiorna`;

    try {
      const res = await this.http.put(url, payload);
      this.eventBus.emit('data-load-success', { message: res.data.message });
      return res.data;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
      return null;
    } finally {
      this.eventBus.emit('data-loaded');
    }
  }

  async eliminaAppuntamentoSospensioneRiattivazione(payload) {
    const url = `${this.praticheBaseUrl}/api/sospensioni-riattivazioni-management/appuntamento/elimina`;

    try {
      const res = await this.http.delete(url, {
        data: payload,
      });

      this.eventBus.emit('data-load-success', { message: res.data.message });
      return res.data;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
      return null;
    } finally {
      this.eventBus.emit('data-loaded');
    }
  }

}
